/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UploadBrandHeroImageRequest} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'
import {UploadBrandHeroImageResponse} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'


export const uploadBrandHeroImage = (request: UploadBrandHeroImageRequest, options?: CashRequestOptions) => post<UploadBrandHeroImageRequest, UploadBrandHeroImageResponse>("/2.0/cash/upload-brand-hero-image", request, {...options, rejectOnError: true })